import React, { Component, Fragment } from 'react';

import InputToggle from 'components/input/toggle/InputToggle';
import { Loader } from 'components/loader';
import { I18n, translate } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import ConfigService from '../ConfigService';

import './ConfigCustomizationAsk.scss';

@translate()
@inject('MembershipStore')
@observer
export default class ConfigCustomizationAsk extends Component {
  static propTypes = {
    MembershipStore: MobxPropTypes.objectOrObservableObject
  };

  state = {
    loader: true,
    askStatus: false,
    disabled: false
  };

  getAskStatus() {
    const { productId } = this.props.MembershipStore;

    ConfigService.getAskStatus(productId)
      .then((data) => {
        this.setState({
          loader: false,
          askStatus: data.enabled,
          disabled: false
        });
      })
      .catch(() => {
        this.setState({ loader: false, disabled: true });
      });
  }

  changeAskStatus = ({ target: { value } }) => {
    const { productId } = this.props.MembershipStore;

    this.setState({ askStatus: value });
    ConfigService.changeAskStatus(productId, value).then(() => {
      this.setState({ askStatus: value });
    });
  };

  componentDidMount() {
    this.getAskStatus();
  }

  render() {
    const { loader, askStatus, disabled } = this.state;

    return (
      <Fragment>
        {loader && <Loader key="loader" mask />}

        <div
          className="grid grid__block configcustomizationask"
          data-test="settings-customization-ask"
        >
          <h2>
            <I18n label="general.ask" />
          </h2>

          <div className="ask_box_content">
            <div className="ask_box_text">
              <p>
                <I18n label="config_manager.config_data.ask_description" />
              </p>
            </div>
            <div className="ask_box_icon">
              <i className="icon icon-ask-icon" />
            </div>
          </div>

          <div className="ask_toggle">
            <InputToggle
              id="enableAsk"
              key="enableAsk"
              name="enableAsk"
              disabled={disabled}
              value={askStatus}
              labelValue="config_manager.config_custom.enable_ask"
              labelClass="secondary"
              onChange={this.changeAskStatus}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
